import gsap from 'gsap';
import {cartClass, scrollInstance, swupInstance} from './main';
import { detectedDevice } from 'detected-device';

export default class Header {
    constructor() {
        this.header = document.querySelector('header');
        this.languageSelector = this.header.querySelector('.header--language');
        this.menuNavigationItems = this.header.querySelectorAll('.header--left .header--menu li, .header--contatti-link span');
        this.isLanguageSelectorOpen = false;
        this.mobileOpener = this.header.querySelector('.mobile--menu-opener');
        this.mobileMenu = document.querySelector('.mobile--menu');
        this.mobileMenuIsOpen = false;
        this.mobileMenuIsAnimating = false;
        this.init();
    }
    init() {
        this.switchLanguageSelector();
        this.header.querySelector('.header--cart').addEventListener('click', () => cartClass.open());
        this.handleMenuNavigation();
        this.handleMobileMenuNavigation();

        this.mobileOpener.addEventListener('click', () => {
            if(!this.mobileMenuIsAnimating) {
                if(this.mobileOpener.classList.contains('open')) {
                    this.closeMobileMenu();
                } else {
                    this.openMobileMenu();
                }
            }
        });
    }
    switchLanguageSelector() {
        this.languageSelector.querySelector('.current--language').addEventListener('click', () => {
            if(this.isLanguageSelectorOpen) {
                gsap.to(this.languageSelector.querySelector('.list--languages'), {x: '2vw', autoAlpha: 0, duration: .5, ease: 'power2.inOut'});
                this.isLanguageSelectorOpen = false;
            } else {
                gsap.to(this.languageSelector.querySelector('.list--languages'), {x: 0, autoAlpha: 1, duration: .5, ease: 'power2.inOut'});
                this.isLanguageSelectorOpen = true;
            }
        });
    }
    handleMenuNavigation() {
        this.menuNavigationItems.forEach(item => {
            item.addEventListener('click', () => {
                const targetId = item.dataset.id;
                const lang = document.documentElement.lang;
                const basePath = lang && lang !== 'it-IT' ? `/en` : '';
                const isHome = window.location.pathname === '/' || window.location.pathname === `/en/` || window.location.pathname === `/${lang}/`;

                if (isHome || document.getElementById(targetId)) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        scrollInstance.scrollTo(targetElement, { duration: 2 });
                    }
                } else {
                    // Salva il target prima di navigare
                    sessionStorage.setItem('scrollTarget', targetId);
                    swupInstance.navigate(`${basePath}/`);
                }
            });
        });
    }
    async handleMobileMenuNavigation() {
        this.mobileMenu.querySelectorAll('.menu--nav ul li').forEach(item => {
            item.addEventListener('click', async () => {
                const targetId = item.dataset.id;
                const lang = document.documentElement.lang;
                const basePath = lang && lang !== 'it-IT' ? `/en` : '';
                const isHome = window.location.pathname === '/' || window.location.pathname === `/en/` || window.location.pathname === `/${lang}/`;

                if (isHome || document.getElementById(targetId)) {
                    if (this.mobileMenuIsOpen) await this.closeMobileMenu();
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        scrollInstance.scrollTo(targetElement, { duration: 2 });
                    }
                } else {
                    if (this.mobileMenuIsOpen) await this.closeMobileMenu();
                    sessionStorage.setItem('scrollTarget', targetId);
                    swupInstance.navigate(`${basePath}/`);
                }
            });
        });
    }
    async openMobileMenu() {
        this.mobileMenuIsAnimating = true;
        this.mobileOpener.classList.add('open');

        gsap.set(this.mobileMenu, { autoAlpha: 1 });

        await gsap.to(this.mobileMenu.querySelector('.menu--bg'), {
            height: '100%',
            duration: 0.5,
            ease: 'power2.inOut'
        });

        await gsap.to(this.mobileMenu.querySelectorAll('.animate-mobile'), {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: 'power2.out',
            stagger: 0.05
        });

        this.mobileMenuIsAnimating = false;
        this.mobileMenuIsOpen = true;
    }
    async closeMobileMenu() {
        this.mobileMenuIsAnimating = true;
        await gsap.to(this.mobileMenu.querySelectorAll('.animate-mobile'), { y: 40, autoAlpha: 0, stagger: -0.03, duration: 0.4, ease: 'power1.out' });
        await gsap.to(this.mobileMenu.querySelector('.menu--bg'), { height: '0%', duration: .5, ease: 'power2.inOut' });
        await gsap.set(this.mobileMenu, { autoAlpha: 0 });
        this.mobileOpener.classList.remove('open');
        this.mobileMenuIsAnimating = false;
        this.mobileMenuIsOpen = false;
    }
}